import * as React from 'react';

import classNames from 'classnames';

import { useTheme } from '@coursera/cds-core';
import { SvgPauseFilled, SvgPlayFilled } from '@coursera/coursera-ui/svg';

import { TooltipWrapper } from 'bundles/common/components/Tooltip';
import ToggleSwitchStandalone from 'bundles/video-player/components/autoplay-standalone/ToggleSwitchStandalone';

import _t from 'i18n!nls/general-video-player';

type Props = {
  isAutoPlayEnabled: boolean;
  onAutoPlayChange?: (isAutoPlayEnabled: boolean) => void;
};

const ICON_SIZE = 10;

const AutoplayToggleStandalone = ({ isAutoPlayEnabled, onAutoPlayChange }: Props) => {
  const { palette } = useTheme();
  const tooltip = isAutoPlayEnabled ? _t('Autoplay is on') : _t('Autoplay is off');
  const label = tooltip;

  const handleToggleSwitchClick = () => {
    onAutoPlayChange?.(!isAutoPlayEnabled);
  };

  return (
    <TooltipWrapper placement="top" message={tooltip}>
      <ToggleSwitchStandalone
        ariaLabel={label}
        onToggle={handleToggleSwitchClick}
        value={isAutoPlayEnabled}
        className={classNames('vjs-button', 'c-vjs-button', 'c-video-control', 'align-items-absolute-center')}
        offIcon={
          <SvgPauseFilled
            size={ICON_SIZE}
            color={palette.white}
            suppressTitle
            style={{ position: 'relative', left: '1px', top: '1px' }}
          />
        }
        onIcon={
          <SvgPlayFilled
            size={ICON_SIZE}
            color={palette.gray[500]}
            suppressTitle
            style={{ position: 'relative', left: '1px', top: '1px' }}
          />
        }
      />
      {/* The tooltip doesn't work without this span present!?! */}
      <span className="vjs-control-text">{label}</span>
    </TooltipWrapper>
  );
};

export default AutoplayToggleStandalone;
